module.exports = __webpack_public_path__ + "static/media/corruption.6f77b1a1.svg";